"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const data_source_provider_1 = require("./data.source.provider");
class DataSourceProviderRemote extends data_source_provider_1.DataSourceProvider {
    constructor(name) {
        super(name, data_source_provider_1.DataSourceType.Remote);
        // if (JustDetective.simpleDetect(instance)) {
        //     this.remoteInstance = instance;
        // } else { this.remoteInstance = null; }
    }
}
exports.DataSourceProviderRemote = DataSourceProviderRemote;
//# sourceMappingURL=data.source.provider.remote.js.map